export default __webpack_public_path__ + "static/media/drone.117d16ca.svg";